import Logo from '../components/shared/icons/paymentMethodLogos/index';

// Payment method/sub-type names returned by payments web API
const VISA_ELECTRON = 'VisaElectron';
const MASTERCARD = 'Mastercard';
export const CREDIT_CARD = 'CreditCard';
export const CREDITS = 'Credits';
export const ZBD = 'ZeroBalanceDue';

// Maps payment method/sub-type name to its logo map key
export const paymentMethodNameMap = {
  [VISA_ELECTRON]: 'visa',
  [MASTERCARD]: 'mc',
};

// Maps payment method key to its logo component
export const paymentMethodLogoMap = {
  visa: Logo.Visa(),
  mc: Logo.Mastercard(),
  amex: Logo.Amex(),
  discover: Logo.Discover(),
  paypal: Logo.PayPal(),
  credits: Logo.MerchCredits(),
  ideal: Logo.Ideal(),
  sofort: Logo.Sofort(),
  klarna: Logo.Klarna(),
  multibanco: Logo.Multibanco(),
  applepay: Logo.ApplePay(),
  afterpay: Logo.Afterpay(),
};
